import React, { useState, useEffect } from "react";
import {
  Card,
  Chip,
  Grid,
  Box,
  Stack,
  useMediaQuery,
  IconButton,
  Menu,
  MenuItem,
  Autocomplete,
  TextField,
  Popper,
  Checkbox,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { useDispatch, useSelector } from "react-redux";
import EnhancedTableHead from "pages/components/common/EnhancedTableHead";
import { getUserListingData } from "redux-store/users/actions";
import SearchIcon from "@mui/icons-material/Search";
import Skeleton from "@mui/material/Skeleton";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import KendoInput from "assets/theme/components/inputKendo";
import DashboardLayout from "pages/components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/DashboardNavbar";
import toast from "react-hot-toast";
import { AssetService } from "api/users.api";
import SoftButton from "components/SoftButton";
import ProfileAvatar from "pages/components/ProfileAvtar";
import DeleteVendorModel from "./DeleteVendor";
import AssignAssetsModel from "./AssignAssets";
import SoftTypography from "components/SoftTypography";
import { tablePaperStyle } from "pages/components/common/Styles";

const staticUsers = [
  {
    id: 1,
    firstName: "John",
    lastName: "Doe",
    mobileNumber: "123-456-7890",
    email: "john.doe@example.com",
    enabled: true,
    createdAt: "2025-03-04T10:30:00Z",
  },
  {
    id: 2,
    firstName: "Jane",
    lastName: "Smith",
    mobileNumber: "987-654-3210",
    email: "jane.smith@example.com",
    enabled: false,
    createdAt: "2025-03-03T15:45:00Z",
    status: "active",
  },
  {
    id: 3,
    firstName: "Michael",
    lastName: "Johnson",
    mobileNumber: null,
    email: "michael.j@example.com",
    enabled: true,
    createdAt: "2025-03-02T08:20:00Z",
  },
  {
    id: 4,
    firstName: "Ram",
    lastName: "Singh",
    mobileNumber: "987-654-3210",
    email: "ram.singh@example.com",
    enabled: false,
    createdAt: "2025-03-03T15:45:00Z",
    status: "inactive",
  },
  {
    id: 5,
    firstName: "Pankaj",
    lastName: "Singh",
    mobileNumber: null,
    email: "pankaj.s@example.com",
    enabled: true,
    createdAt: "2025-03-02T08:20:00Z",
    status: "active",
  },
];

const VendorList = ({ refresh }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [searchEmail, setSearchEmail] = useState("");
  const [devices, setDevices] = useState([]);
  const [refreshRecords, setRefreshRecords] = useState(false);
  const [filters, setFitters] = useState({
    keyword: "",
    sensorCategoryId: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const dispatch = useDispatch();
  const [search, setSearch] = useState({});
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("created_at");
  const [pageSize, setPageSize] = useState(10);
  const [selected, setSelected] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [sensorCategories, setSensorCategories] = useState([]);
  const [deleteAssetModalOpen, setDeleteAssetModalOpen] = useState(false);
  const [assignAssetsModel, setAssignAssetsModel] = useState(false);
  const { error, data } = useSelector((state) => state.users.getUserListingData);

  const getUserAssets = async (filters) => {
    try {
      setLoading(true);
      const response = await AssetService.getUserAssets(filters);
      console.log(response);
      setRecords(response?.data?.data?.data ?? []);
      setTotalRecords(response?.data?.data?.totalRecords ?? 0);
    } catch (error) {
      console.error(error);
      if (!!error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error(error?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  console.log("records", records);
  console.log("filters", filters);

  /**
   * Handle page change and refeacth data
   *
   * @param {*} event
   * @param {*} newPage
   */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  /**
   * On change page size
   *
   * @param {*} event
   */
  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  /**
   * Handle sorting change
   *
   * @param {*} event
   * @param {*} property
   */
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Handle action menu open/close
  const handleMenuOpen = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(user);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = (asset) => {
    setDeleteAssetModalOpen(true);
    handleMenuClose();
  };

  const handleAssignAsset = () => {
    setAssignAssetsModel(true);
    handleMenuClose();
  };

  const handleViewDetails = () => {
    navigate(`/vendor/details`);
  };

  const handleEdit = () => {
    if (!selectedItem) {
      return false;
    }

    if (selectedItem?.assetCategoryId === 1) {
      navigate(`/assets/edit?d=1&s=${selectedItem?.systemId}`);
    }

    if (selectedItem?.assetCategoryId === 2) {
      navigate(`/assets/edit?d=2&s=${selectedItem?.systemId}`);
    }

    if (selectedItem?.assetCategoryId === 3) {
      navigate(`/assets/edit?d=3&s=${selectedItem?.systemId}`);
    }
  };

  const handleActivate = () => {
    if (!selectedItem) {
      return false;
    }
    if (selectedItem?.assetCategoryId === 1) {
      navigate(`/device/checkout?d=${selectedItem?.deviceNumber}`);
    }
  };

  useEffect(() => {
    getUserAssets({
      ...filters,
      pageNumber: page + 1,
      pageSize: pageSize,
      order: order,
      orderBy: orderBy,
    });
  }, [page, pageSize, order, orderBy, refreshRecords]);

  const handleSearchAssets = (e) => {
    setRefreshRecords(!refreshRecords);
  };

  console.log("selected", selectedItem);

  const handleSearch = (users) =>
    users.filter((user) => user.email?.toLowerCase() || `${user.firstName} ${user.lastName}`);

  const filteredUsers = handleSearch((data?.users && data?.users.length > 0 && data?.users) || []);

  useEffect(() => {
    dispatch(getUserListingData(page + 1));
  }, [refresh]);

  const getStatusLabel = (status) => (status === "active" ? "Active" : "Inactive");

  const options = [
    { label: "Device", value: "1" },
    { label: "Data", value: "2" },
    { label: "Item", value: "3" },
  ];

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (event, newValue) => {
    setSelectedOptions(newValue);
    setFitters({
      ...filters,
      assetCategoryId: newValue.map((option) => option.value),
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <SoftTypography variant="h4" mb={2}>
          Vendor Listing
        </SoftTypography>
        <Card sx={{ padding: 3 }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", md: "center" }}
            spacing={2}
            pb={2}
            mt={2}
            mb={2}
          >
            <Grid>
              <SoftBox>
                <Link to="/vendor/add">
                  <SoftButton variant="outlined" color="info" size={"medium"}>
                    + Add Vendor
                  </SoftButton>
                </Link>
              </SoftBox>
            </Grid>
            <Grid>
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                sx={{ flexWrap: "wrap" }}
              >
                <Grid item>
                  <KendoInput
                    placeholder="Search..."
                    type="search"
                    value={filters?.keyword}
                    onChange={(e) =>
                      setFitters({
                        ...filters,
                        keyword: e.target.value,
                      })
                    }
                  />
                </Grid>
                {/* Dropdowns */}

                <Grid item>
                  <Autocomplete
                    disablePortal
                    options={options}
                    sx={{ width: 200 }}
                    onChange={(event, newValue) => {
                      setSelectedItem(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select Vendor Type" variant="outlined" />
                    )}
                  />
                </Grid>

                <Grid item>
                  <SoftButton variant="gradient" color="info">
                    search
                  </SoftButton>
                </Grid>
              </Grid>
            </Grid>
          </Stack>

          <Paper sx={tablePaperStyle}>
            <Box>
              {loading ? (
                <Skeleton variant="rectangular" height={300} animation="wave" />
              ) : (
                <>
                  <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={filteredUsers.length}
                        headCells={headCells}
                      />

                      <TableBody>
                        {staticUsers.length === 0 && (
                          <TableRow key={1}>
                            <TableCell colSpan={8} align="center">
                              No records found.
                            </TableCell>
                          </TableRow>
                        )}

                        {staticUsers.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>
                              <SoftBox display="flex">
                                <SoftBox>
                                  <ProfileAvatar name={`${row.firstName} ${row.lastName}`} />
                                </SoftBox>
                                <SoftBox mx={2}>{`${row.firstName} ${row.lastName}`}</SoftBox>
                              </SoftBox>
                            </TableCell>
                            <TableCell>
                              <SoftBox>{row.mobileNumber ? row.mobileNumber : "--"}</SoftBox>
                              <SoftBox fontSize="0.875rem">{row.email ? row.email : "--"}</SoftBox>
                            </TableCell>
                            <TableCell align="left">
                              <Chip
                                label={getStatusLabel(row?.status)}
                                color={row.status === "active" ? "success" : "warning"}
                                size="small"
                              />
                            </TableCell>
                            <TableCell align="left">
                              {row.createdAt
                                ? dayjs(row.createdAt).format("YYYY-MM-DD hh:mm:ss A")
                                : "-"}
                            </TableCell>
                            <TableCell>
                              <IconButton onClick={(event) => handleMenuOpen(event, row)}>
                                <MoreVertIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Menu
                    id="menu-basic"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={handleEdit}>Edit</MenuItem>
                    {selectedItem?.status == 0 && (
                      <MenuItem onClick={handleActivate}>Activate</MenuItem>
                    )}
                    <MenuItem onClick={handleAssignAsset}>Assign Asset</MenuItem>
                    <MenuItem onClick={handleViewDetails}>View Vendor Details</MenuItem>
                    <MenuItem onClick={handleDelete}>Delete</MenuItem>
                  </Menu>
                  <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={totalRecords ?? 0}
                    rowsPerPage={pageSize ?? 10}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </>
              )}
            </Box>
          </Paper>
          <DeleteVendorModel
            open={deleteAssetModalOpen}
            handleClose={() => {
              setDeleteAssetModalOpen(false);
            }}
            asset={selectedItem}
            refresh={refreshRecords}
            setRefresh={setRefreshRecords}
          />
          <AssignAssetsModel
            open={assignAssetsModel}
            handleClose={() => {
              setAssignAssetsModel(false);
            }}
            refresh={refreshRecords}
            setRefresh={setRefreshRecords}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
};

export default VendorList;

const headCells = [
  {
    id: "user",
    numeric: true,
    disablePadding: true,
    label: "Vendor",
    sortable: false,
  },
  {
    id: "mobile",
    numeric: false,
    disablePadding: false,
    label: "Cotanct",
    sortable: false,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    sortable: false,
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    sortable: false,
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
    sortable: false,
  },
];
